import CustomMargin from '../../components/custom-margin';
import AttyProfile from './components/atty-profile';
import MissionAbout from './components/mission-about';
import GlobalContact from '../../components/global-contact';
import SEO from '../../components/seo';

export default function AboutUs(){
    
    return(
        <div className='overflow-hidden bg-[#090909] pb-12 text-zinc-300'>
            <SEO
                title="About Quilaton Law Office | Cebu City Lawyers"
                description="Learn about Quilaton Law Office, its founding owner, mission, vision, values, and legal service commitment in Cebu City."
                path="/about/"
            />
            <AttyProfile/>
            <div className='relative mb-14 flex flex-col items-center justify-center overflow-hidden bg-buildingBg bg-cover p-5 text-white'>
                <div className="absolute inset-0 bg-black/75" />
                <MissionAbout/>
            </div>
            <CustomMargin className="px-5 lg:px-10">
                <div className='flex flex-col justify-center items-center h-auto mb-10'>
                    <div className='mb-6 text-center font-fontMontserrat text-zinc-100 
                                    sm:text-2xl sm:mb-5
                                    lg:text-4xl
                                    xxl:text-5xl'>
                        <p>JY Square Mall Office</p>
                        <p>Directional Video</p>
                    </div>
                    <div className="overflow-hidden rounded-2xl border border-zinc-700 bg-black p-1 shadow-2xl shadow-black/50"><iframe className='w-[550px] h-[1100px] 
                                    sm:w-[150px] sm:h-[300px]
                                    lg:w-[350px] lg:h-[700px]
                                    xxl:w-[550px] xxl:h-[1100px]' 
                            title='Facebook Video' 
                            frameBorder="0"
                            allow="autoplay; encrypted-media"
                            allowFullScreen
                            src="https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Fwatch%2F%3Fv%3D1698434457605329&show_text=0&autoplay=1"> 
                    </iframe></div>
                </div>
            </CustomMargin>
        </div>
    );
}
